import { graphql } from 'react-relay/legacy';

const homepageRootQuery = graphql`
    query homepageRootQuery(
        $isMobile: Boolean!
        $homepageId: String!
        $userId: String!
        $hasUserId: Boolean!
        $fetchInitialHomepage: Boolean!
        $localRecentHistoryList: [LocalRecentHistoryListInputType] = []
        $recentActivityDesignVariant: String = "default"
        $auctionItemsCount: Int!
        $userType: String!
        $isTrade: Boolean!
        $userCountryCode: String = ""
        $abTestList: [String] = []
    ) {
        viewer {
            ...HpSharedLayout_viewer
            homepage(rootId: $homepageId, abTestList: $abTestList) {
                ...getHomePageMetaContent_homepage @relay(mask: false)
                # necessary to throw error & not cache homepage if no modules return
                modules {
                    __id
                }
            }
        }
    }
`;

const homepageVariables = {
    fetchInitialHomepage: true,
    hasRecentlyViewedItems: false,
    isMobile: false,
    homepageId: '',
    userId: '',
    hasUserId: false,
    recentlyViewedItemIds: [],
    userIds: [],
    isClient: false,
    countryCode: '',
    zipCode: '',
    auctionItemsCount: 0,
    userType: '',
    isTrade: false,
    userCountryCode: '',
};

export { homepageRootQuery, homepageVariables };
